import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowRight, faInfoCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './ConvertProformaConfirmModal.css';

function ConvertProformaConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  proforma
}) {
  if (!isOpen || !proforma) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const formatCurrency = (amount, currency) => {
    if (!amount || isNaN(amount)) return '0.00';
    return parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div className="convert-proforma-modal-overlay" onClick={handleCancel}>
      <div className="convert-proforma-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="convert-proforma-modal-header">
          <div className="convert-proforma-header-content">
            <h3 className="convert-proforma-modal-title">
              <FontAwesomeIcon icon={faArrowRight} /> Submit for Conversion Approval
            </h3>
          </div>
          <button className="convert-proforma-close-btn" onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="convert-proforma-modal-body">
          <div className="convert-proforma-warning-banner">
            <FontAwesomeIcon icon={faInfoCircle} />
            <div className="convert-proforma-warning-text">
              <strong>Approval Required</strong>
              <p>This pro forma invoice will be submitted to financial approvers for conversion approval.</p>
            </div>
          </div>

          <div className="convert-proforma-confirm-message">
            <p className="convert-proforma-question">
              Are you sure you want to submit this pro forma for conversion to an outgoing invoice?
            </p>
          </div>

          {/* Pro Forma Details Card */}
          <div className="convert-proforma-details-card">
            <h4 className="convert-proforma-details-title">Pro Forma Invoice Details</h4>
            
            <div className="convert-proforma-detail-row">
              <div className="convert-proforma-detail-label">Invoice Number</div>
              <div className="convert-proforma-detail-value convert-proforma-invoice-number">
                {proforma.invoice_number}
              </div>
            </div>

            <div className="convert-proforma-detail-row">
              <div className="convert-proforma-detail-label">Partner</div>
              <div className="convert-proforma-detail-value">
                {proforma.partner_name || 'N/A'}
              </div>
            </div>

            <div className="convert-proforma-detail-row">
              <div className="convert-proforma-detail-label">Invoice Date</div>
              <div className="convert-proforma-detail-value">
                {formatDate(proforma.invoice_date)}
              </div>
            </div>

            <div className="convert-proforma-detail-row">
              <div className="convert-proforma-detail-label">Amount</div>
              <div className="convert-proforma-detail-value convert-proforma-amount-highlight">
                {proforma.currency} {formatCurrency(proforma.gross_amount, proforma.currency)}
              </div>
            </div>

            <div className="convert-proforma-detail-row">
              <div className="convert-proforma-detail-label">Status</div>
              <div className="convert-proforma-detail-value">
                <span className="convert-proforma-status-badge">
                  {proforma.status}
                </span>
              </div>
            </div>
          </div>

          {/* Impact Notice */}
          <div className="convert-proforma-impact-notice">
            <FontAwesomeIcon icon={faCheckCircle} />
            <div className="convert-proforma-impact-text">
              <strong>What happens next:</strong>
              <ul>
                <li>Pro forma will be submitted for conversion approval</li>
                <li>Financial approvers will be notified</li>
                <li>Upon approval, an outgoing invoice will be automatically created</li>
                <li>You will be notified of the approval decision</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="convert-proforma-modal-footer">
          <button className="convert-proforma-btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
          <button className="convert-proforma-btn-primary" onClick={handleConfirm}>
            <FontAwesomeIcon icon={faArrowRight} /> Submit for Approval
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConvertProformaConfirmModal;

